import { container } from '@eureka/services'
import type { ICoreDataWrapper } from '@eureka/services/src/exception';
import type { NavHistoryResponse } from '../../types'

export function getHistoryList() {
    return container.RnDHttp.get<ICoreDataWrapper<NavHistoryResponse>>({
        // @ts-ignore
        url: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/history/records`,
        params: {
            page: 1,
            pageSize: 100,
            type: 'playbook',
            duration: 1,
            tzOffset: -(new Date()).getTimezoneOffset(),
        },
    }).then((res) => {
        return res.data
    })
}

export function removeHistory(historyId: string) {
    return container.RnDHttp.delete<ICoreDataWrapper<boolean>>({
        // @ts-ignore
        url: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/history`,
        data: {
            type: 'playbook',
            history_ids: [historyId],
        },
    }).then((res) => {
        return res.status
    })
}

export function removeAllRecords() {
    return container.RnDHttp.delete<ICoreDataWrapper<boolean>>({
        // @ts-ignore
        url: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/history`,
        data: {
            type: 'all',
        },
    }).then((res) => {
        return res.status
    })
}
